import React from "react";
import { Element } from "react-scroll";
import { FaBriefcase } from "react-icons/fa";
import "./Experience.css";

const Experience = () => {
  const experiences = [
    {
      position: "Full Stack Developer Intern",
      company: "FFT 15forTeen (educational startup)",
      period: "July 2024 – August 2024",
      tasks: [
        "Designed a user-friendly website interface tailored to business and employee needs.",
        "Implemented a secure payment gateway to enhance e-commerce functionality.",
        "Developed systems for efficient notes management and accessibility.",
        "Built a scalable, robust backend architecture ensuring seamless integration and performance.",
        "Collaborated with cross-functional teams to align project goals and deliverables.",
      ],
    },
    {
      position: "Machine Learning Research Assistant",
      company: "NSUT Research Lab",
      period: "June 2023 - August 2023",
      tasks: [
        "Conducted research on deep learning algorithms for image classification",
        "Implemented CNN models using TensorFlow and PyTorch frameworks",
        "Analyzed datasets and performed data preprocessing techniques",
        "Contributed to research paper on AI applications in healthcare",
        "Mentored junior students in machine learning concepts",
      ],
    },
  ];

  return (
    <Element name="experience">
      <section className="experience" style={{ padding: "2rem 2rem" }}>
        <div className="experience-container">
          <h2 className="section-title">Experience</h2>
          <div className="experience-list">
            {experiences.map((exp, index) => (
              <div
                key={index}
                className="experience-card"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <div className="experience-header">
                  <div className="experience-icon">
                    <FaBriefcase />
                  </div>
                  <div className="experience-info">
                    <h3>{exp.position}</h3>
                    <h4>{exp.company}</h4>
                    <span className="experience-period">{exp.period}</span>
                  </div>
                </div>
                <div className="experience-tasks">
                  <h5>Key Responsibilities:</h5>
                  <ul>
                    {exp.tasks.map((task, taskIndex) => (
                      <li key={taskIndex}>{task}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Element>
  );
};

export default Experience;
